import { action, makeAutoObservable, runInAction } from "mobx";
import { Api } from "../../common/Api";
import { RegionFilterStore } from "../RegionFilterStore";

export class OrgsStore2 {
  loading = false;

  filterStore: RegionFilterStore;

  filter: any = {
    page: 0,
    size: 100,
    keyword: "",
    regionId: "",
    divisionId: "",
    communityId: "",
    period: [undefined, undefined],
  };

  data = {
    total: 0,
    items: [],
  };

  constructor() {
    makeAutoObservable(this, {});
    this.filterStore = new RegionFilterStore(this);
    this.filterStore.showPeriod = false;
  }

  get pagination() {
    return {
      current: this.filter.page + 1,
      pageSize: this.filter.size,
      total: this.data.total,
    };
  }

  get items() {
    return this.data.items;
  }

  @action onSearch(history) {
    const query = new URLSearchParams({ ...this.filter, page: 0 });
    history.push({ search: query.toString() });
  }

  @action onPage(history, page, pageSize) {
    const query = new URLSearchParams({ ...this.filter, page: page - 1, size: pageSize });
    history.push({ search: query.toString() });
  }

  @action onLocation(location) {
    const params = new URLSearchParams(location.search);
    const keyword = params.get("keyword") || "";
    const regionId = params.get("regionId") || "";
    const divisionId = params.get("divisionId") || "";
    const communityId = params.get("communityId") || "";
    const page = parseInt(params.get("page") || "0");
    const size = parseInt(params.get("size") || "100");
    this.filter = { page, size, keyword, regionId, divisionId, communityId };
    this.refresh();
  }

  @action
  refresh() {
    this.loading = true;
    const { keyword, page, size, regionId, divisionId, communityId } = this.filter;
    const filter: any = { keyword, page, size, regionId, divisionId, communityId };

    Api.org
      .orgs(filter)
      .then((res) => {
        runInAction(() => {
          let data = res.data.orgs;
          this.data = data;
        });
      })
      .finally(() => (this.loading = false));
  }
}

export const orgsStore = new OrgsStore2();
